import { render, staticRenderFns } from "./TagPromocionHallazgosAdicionales.vue?vue&type=template&id=2d83940f&scoped=true"
import script from "./TagPromocionHallazgosAdicionales.vue?vue&type=script&lang=js"
export * from "./TagPromocionHallazgosAdicionales.vue?vue&type=script&lang=js"
import style0 from "./TagPromocionHallazgosAdicionales.vue?vue&type=style&index=0&id=2d83940f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d83940f",
  null
  
)

export default component.exports